import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Loader2 } from "lucide-react";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    async function logoutUser() {
      try {
        const response = await fetch("/api/auth/logout", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          // Successfully logged out, redirect to home page
          navigate("/");
          window.location.reload();
        } else {
          // Handle error case - still redirect to home but maybe show an error
          console.error("Logout failed", response.statusText);
          navigate("/");
          window.location.reload();
        }
      } catch (error) {
        console.error("Logout error:", error);
        navigate("/");
        window.location.reload();
      }
    }

    logoutUser();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh]">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="mt-4 text-lg">Logging out...</p>
    </div>
  );
}
